import React from "react";
import { Form } from "react-bootstrap";
import { debounce } from "lodash";

const SearchBox = ({ setCurrentPage, setSearchQuery }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = React.useCallback(
    debounce((value) => {
      setSearchQuery(value);
      setCurrentPage(1);
    }, 500),
    [],
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    debouncedSearch(value);
  };

  return (
    <Form.Control
      type="text"
      placeholder="Search"
      className="mr-sm-2"
      size="sm"
      onChange={handleSearchChange}
    />
  );
};

export default SearchBox;
